'use client';

import { useScroll } from 'ahooks';
import Link from 'next/link';
import { cn } from '@/app/utils';
import type { TemplateCategory } from '../types';

interface CategoryTabsProps {
  categories: TemplateCategory[];
  activeCategory?: string;
  /** e.g. "/ai-templates"；用于构造 All / 分类的 Link href */
  basePath: string;
}

export default function CategoryTabs({ categories, activeCategory, basePath }: CategoryTabsProps) {
  const offset = useScroll(typeof window !== 'undefined' ? document : null);

  return (
    <div
      className={cn(
        'sticky top-[156px] z-10 pb-8 transition-colors duration-300 sm:top-[118px] sm:pb-2',
        (offset?.top ?? 0) > 210 && 'bg-black/95 backdrop-blur-sm',
      )}
    >
      <div className="hide-scrollbar m-auto flex w-full max-w-[1312px] flex-nowrap items-center gap-2 overflow-x-auto px-16 sm:mt-2 sm:px-4">
        <Link
          prefetch={false}
          href={basePath}
          className={cn(
            'flex h-[28px] min-w-[62px] flex-shrink-0 items-center justify-center rounded-8 px-3 text-center font-normal text-sm transition-all duration-200',
            !activeCategory ? 'bg-white text-black' : 'bg-white/10 text-white',
          )}
        >
          All
        </Link>

        {categories.map((category) => (
          <Link
            prefetch={false}
            key={category._id}
            href={`${basePath}?category=${category.slug}`}
            className={cn(
              'flex h-[28px] min-w-[62px] flex-shrink-0 items-center justify-center rounded-8 px-3 text-center font-normal text-sm transition-all duration-200',
              activeCategory === category.slug ? 'bg-white text-black' : 'bg-white/10 text-white',
            )}
          >
            {category.title}
          </Link>
        ))}
      </div>
    </div>
  );
}
